import { documentConstants } from "../../constants";
import { documentService } from "../../../services/api.documents";
import { notify } from "reapop";
import { OperationDocumentType } from "../../../helpers/enums";

export const invoiceActions = {
  getAll,
  getById,
  create,
  update,
  archive,
  changeStatus,
  changeViewStatus,
  // слово delete зарезервировано
  delete: _delete
};

function getAll(params) {
  return (dispatch) => {
    dispatch(request());

    documentService.getAllInvoices(params).then(
      (response) => dispatch(success(response)),
      (error) => {
        dispatch(failure(error.message));
        dispatch(
          notify({
            title: "Ошибка при получении списка документов на заказ поставщику",
            message: error.message,
            status: "error",
            image: "/public/assets/images/illustrations/close.svg",
          })
        );
      }
    );
  };

  function request() {
    return { type: documentConstants.GETALL_REQUEST_INVOICE };
  }
  function success(response) {
    return { type: documentConstants.GETALL_SUCCESS_INVOICE, response };
  }
  function failure(error) {
    return { type: documentConstants.GETALL_FAILURE_INVOICE, error };
  }
}

function getById(id) {
  return (dispatch) => {
    dispatch(request(id));

    documentService.getInvoiceById(id).then(
      (response) => {
        dispatch(success(response));
      },
      (error) => {
        dispatch(failure(error.message));
        dispatch(
          notify({
            title: "Ошибка",
            message: error.message,
            status: "error",
            image: "/public/assets/images/illustrations/close.svg",
          })
        );
      }
    );
  };

  function request(id) {
    return { type: documentConstants.GETBYID_REQUEST_INVOICE, id };
  }
  function success(response) {
    return { type: documentConstants.GETBYID_SUCCESS_INVOICE, response };
  }
  function failure(error) {
    return { type: documentConstants.GETBYID_FAILURE_INVOICE, error };
  }
}

function create(params) {
  return (dispatch) => {
    dispatch(request(params));

    documentService.createInvoice(params).then(
      (response) => {
        dispatch(success(response.result));
        dispatch(
          notify({
            title: "Успешно",
            message: response.message,
            status: "success",
            image: "/public/assets/images/illustrations/check.svg",
          })
        );
      },
      (error) => {
        dispatch(failure(error.message));
        dispatch(
          notify({
            title: "Ошибка",
            message: error.message,
            status: "error",
            image: "/public/assets/images/illustrations/close.svg",
          })
        );
      }
    );
  };

  function request(response) {
    return { type: documentConstants.CREATE_REQUEST_INVOICE, response };
  }
  function success(response) {
    return { type: documentConstants.CREATE_SUCCESS_INVOICE, response };
  }
  function failure(error) {
    return { type: documentConstants.CREATE_FAILURE_INVOICE, error };
  }
}

function update(id, params) {
  return (dispatch) => {
    dispatch(request(id));

    documentService.updateInvoice(id, params).then(
      (response) => {
        dispatch(success(response.result));
        dispatch(
          notify({
            title: "Успешно",
            message: response.message,
            status: "success",
            image: "/public/assets/images/illustrations/check.svg",
          })
        );
      },
      (error) => {
        dispatch(failure(error.message));
        dispatch(
          notify({
            title: "Ошибка",
            message: error.message,
            status: "error",
            image: "/public/assets/images/illustrations/close.svg",
          })
        );
      }
    );
  };

  function request(id) {
    return { type: documentConstants.UPDATE_REQUEST_INVOICE, id };
  }
  function success(response) {
    return { type: documentConstants.UPDATE_SUCCESS_INVOICE, response };
  }
  function failure(error) {
    return { type: documentConstants.UPDATE_FAILURE_INVOICE, error };
  }
}

function archive(id, type) {
  return (dispatch) => {
    dispatch(request(id));

    documentService.archiveDocument(id, type).then(
      (response) => {
        dispatch(success(id));
        dispatch(
          notify({
            title: "Успешно",
            message: response.message,
            status: "success",
            image: "/public/assets/images/illustrations/check.svg",
          })
        );
      },
      (error) => {
        dispatch(failure(error.message));
        dispatch(
          notify({
            title: "Ошибка",
            message: error.message,
            status: "error",
            image: "/public/assets/images/illustrations/close.svg",
          })
        );
      }
    );
  };

  function request(id) {
    return { type: documentConstants.ARCHIVE_REQUEST_INVOICE, id };
  }
  function success(id) {
    return { type: documentConstants.ARCHIVE_SUCCESS_INVOICE, id };
  }
  function failure(error) {
    return { type: documentConstants.ARCHIVE_FAILURE_INVOICE, error };
  }
}

function changeStatus(id, params) {
  return (dispatch) => {
    dispatch(request(id));

    documentService.changeStatusInvoice(id, params).then(
      (response) => {
        dispatch(success(response.result));
        dispatch(
          notify({
            title: "Успешно",
            message: response.message,
            status: "success",
            image: "/public/assets/images/illustrations/check.svg",
          })
        );
      },
      (error) => {
        dispatch(failure(error.message));
        dispatch(
          notify({
            title: "Ошибка",
            message: error.message,
            status: "error",
            image: "/public/assets/images/illustrations/close.svg",
          })
        );
      }
    );
  };

  function request(id) {
    return { type: documentConstants.STATUS_REQUEST_INVOICE, id };
  }
  function success(response) {
    return { type: documentConstants.STATUS_SUCCESS_INVOICE, response };
  }
  function failure(error) {
    return { type: documentConstants.STATUS_FAILURE_INVOICE, error };
  }
}

function changeViewStatus(id, showMessage = true) {
  return (dispatch) => {
    dispatch(request(id));

    documentService.changeView(id, OperationDocumentType.INVOICE_SUPPLIER).then(
      (response) => {
        dispatch(success(response.result));
        if (showMessage) {
          dispatch(
            notify({
              title: "Успешно",
              message: response.message,
              status: "success",
              image: "/public/assets/images/illustrations/check.svg",
            })
          );
        }
      },
      (error) => {
        dispatch(failure(error.message));
        dispatch(
          notify({
            title: "Ошибка",
            message: error.message,
            status: "error",
            image: "/public/assets/images/illustrations/close.svg",
          })
        );
      }
    );
  };

  function request(id) {
    return { type: documentConstants.VIEW_REQUEST_INVOICE, id };
  }
  function success(response) {
    return { type: documentConstants.VIEW_SUCCESS_INVOICE, response };
  }
  function failure(error) {
    return { type: documentConstants.VIEW_FAILURE_INVOICE, error };
  }
}

function _delete(id, type) {
  return (dispatch) => {
    dispatch(request(id));

    documentService.deleteDocument(id, type).then(
      (response) => {
        dispatch(success(id));
        dispatch(
          notify({
            title: "Успешно",
            message: response.message,
            status: "success",
            image: "/public/assets/images/illustrations/check.svg",
          })
        );
      },
      (error) => {
        dispatch(failure(error.message));
        dispatch(
          notify({
            title: "Ошибка",
            message: error.message,
            status: "error",
            image: "/public/assets/images/illustrations/close.svg",
          })
        );
      }
    );
  };

  function request(id) {
    return { type: documentConstants.DELETE_REQUEST_INVOICE, id };
  }
  function success(id) {
    return { type: documentConstants.DELETE_SUCCESS_INVOICE, id };
  }
  function failure(error) {
    return { type: documentConstants.DELETE_FAILURE_INVOICE, error };
  }
}
